import { isEmpty, isMatch, omit } from 'lodash';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import { Currency } from '@swf/core/enums';
import type { TableParams } from '@swf/generated/types/api/v0/SwHomeGames';

export type HandType = Extract<TableParams['handType'], 'HT_HOLDEM' | 'HT_OMAHA'>;
export type PotStruct = Extract<TableParams['potStruct'], 'STRUCT_NO_LIMIT' | 'STRUCT_POT_LIMIT'>;
export interface FormValues {
  tableName: string;
  handType: HandType;
  potStruct: PotStruct;
  tableSize: number;
  currency: string;
  buyIn: string;
  videoChatSupported: boolean;
}

export interface OptionsFilterResponse {
  options: SelectOption[];
}

export interface OptionsFilter {
  gameData: TableParams[];
  values: FormValues;
}

export const fallback: SelectOption[] = [];

export const getMatchingGameObject = (formState: FormValues, data: TableParams[]) => {
  const objectToMatch = {
    ...omit(formState, ['buyIn', 'tableName']),
    ...omit(JSON.parse(`${formState.buyIn}`), 'id'),
    currency: formState.currency === Currency.PlayMoney ? '' : formState.currency
  };

  return data.find((item) => isMatch(item, objectToMatch));
};

export const getInitialValues = (data: TableParams[] | undefined): FormValues | undefined => {
  if (!data || isEmpty(data)) return;

  const [game] = data;
  const {
    currency,
    handType,
    potStruct,
    maxBuyIn,
    minBuyIn,
    stakesHigh,
    stakesLow,
    tableName,
    tableSize
  } = game;

  return {
    buyIn: JSON.stringify({ id: 0, minBuyIn, maxBuyIn, stakesLow, stakesHigh }),
    currency: currency as string,
    handType: handType as HandType,
    potStruct: potStruct as PotStruct,
    tableName: tableName as string,
    tableSize: Number(tableSize),
    videoChatSupported: false
  };
};
